import { array, boolean, intersect, partial, string, struct } from 'io-ts/Decoder';

import { CountryCode } from '../country';
import { Id as AllocationType } from '../job/allocation-type/Id';

import { Id } from './Id';

export const RefItem = intersect(
	struct({
		id: Id,
	})
)(
	partial({
		name: string,

		allocationTypes: array(AllocationType),
		countryCode: CountryCode,

		isDeleted: boolean,
		isUnknown: boolean,
	})
);
